import { createAction } from '@reduxjs/toolkit';

export const commonSignUp = createAction<{ fromAssetId: string | undefined }>('commonSignUp');
export const commonUpgrade = createAction<{ fromAssetId: string | undefined }>('commonUpgrade');
